import { createSlice } from '@reduxjs/toolkit';
import AILabsState from '../../../constants/AILabs/initialstates/AILabsState';

// Create a Redux slice for the 'dashboard' portion of the state
export const aiLabsSlice = createSlice({
  name: 'ailabs', // The name of the slice
  initialState: AILabsState,
  reducers: {
    setAILabsData: (state, action) => {
      state.data = action.payload;
    },
    setAILabsEtc: (state, action) => {
      state.etc = action.payload;
    },
    setEngineCreationType: (state, action) => {
      state.etc.creationType = action.payload;
    },
    setEngineType: (state, action) => {
      state.data.engineData.engineType = action.payload;
    },
    setEngineTitle: (state, action) => {
      state.data.title = action.payload;
    },
    setEngineData: (state, action) => {
      state.data.engineData = { ...state.data.engineData, ...action.payload };
    },
    setPollingGuideline: (state, action) => {
      state.etc.pollingGuideline = action.payload;
    },
    setDEAGuideline: (state, action) => {
      state.etc.deaGuideline = action.payload;
    },
    setKAIntentGuideline: (state, action) => {
      state.etc.kaIntentGuideline = action.payload;
    },
    setKAFallbackGuideline: (state, action) => {
      state.etc.kaFallbackGuideline = action.payload;
    },
    setKAAnsweringGuideline: (state, action) => {
      state.etc.kaAnsweringGuideline = action.payload;
    },
    setKAFaqGuideline: (state, action) => {
      state.etc.kaFaqGuideline = action.payload;
    },
    setKASpamFilterGuideline: (state, action) => {
      state.etc.kaSpamFilterGuideline = action.payload;
    },
    setKaPersonalizationToolChatGuideline: (state, action) => {
      state.etc.kaPersonalizationToolChatGuideline = action.payload;
    },
    setKaPersonalizationToolGenerationGuideline: (state, action) => {
      state.etc.kaPersonalizationToolGenerationGuideline = action.payload;
    },
    setKaDefaultGuidelines: (state, action) => {
      state.etc.kaDefaultGuidelines = action.payload;
    },
    setKaAnsweringExpanded: (state, action) => {
      state.etc.kaAnsweringExpanded = action.payload;
    },
    setKaIntentExpanded: (state, action) => {
      state.etc.kaIntentExpanded = action.payload;
    },
    setKaFallbackExpanded: (state, action) => {
      state.etc.kaFallbackExpanded = action.payload;
    },
    setKaFaqExpanded: (state, action) => {
      state.etc.kaFaqExpanded = action.payload;
    },
    setKaSpamFilterExpanded: (state, action) => {
      state.etc.kaSpamFilterExpanded = action.payload;
    },
    setKaPersonalizationToolChatExpanded: (state, action) => {
      state.etc.kaPersonalizationToolChatExpanded = action.payload;
    },
    setKaPersonalizationToolGenerationExpanded: (state, action) => {
      state.etc.kaPersonalizationToolGenerationExpanded = action.payload;
    },
    setIntents: (state, action) => {
      state.data.engineData.intents = action.payload;
    },
    setPianoDataSource: (state, action) => {
      const dataSourceIndex = state.data.engineData.dataSources.findIndex(
        ds => ds.type === 'piano'
      );
      if (dataSourceIndex !== -1) {
        state.data.engineData.dataSources[dataSourceIndex] = {
          ...state.data.engineData.dataSources[dataSourceIndex],
          ...action.payload,
        };
      }
    },
    setCapsuleDataSource: (state, action) => {
      const dataSourceIndex = state.data.engineData.dataSources.findIndex(
        ds => ds.type === 'capsule'
      );
      if (dataSourceIndex !== -1) {
        state.data.engineData.dataSources[dataSourceIndex] = {
          ...state.data.engineData.dataSources[dataSourceIndex],
          ...action.payload,
        };
      }
    },
    setClickDataSource: (state, action) => {
      const dataSourceIndex = state.data.engineData.dataSources.findIndex(ds => ds.type === 'qlik');
      if (dataSourceIndex !== -1) {
        state.data.engineData.dataSources[dataSourceIndex] = {
          ...state.data.engineData.dataSources[dataSourceIndex],
          ...action.payload,
        };
      }
    },
    setGa4DataSource: (state, action) => {
      const dataSourceIndex = state.data.engineData.dataSources.findIndex(
        ds => ds.type === 'googleAnalytics'
      );
      if (dataSourceIndex !== -1) {
        state.data.engineData.dataSources[dataSourceIndex] = {
          ...state.data.engineData.dataSources[dataSourceIndex],
          ...action.payload,
        };
      }
    },
    setMailchimpDataSource: (state, action) => {
      const dataSourceIndex = state.data.engineData.dataSources.findIndex(
        ds => ds.type === 'mailchimp'
      );
      if (dataSourceIndex !== -1) {
        state.data.engineData.dataSources[dataSourceIndex] = {
          ...state.data.engineData.dataSources[dataSourceIndex],
          ...action.payload,
        };
      }
    },
    setParselyDataSource: (state, action) => {
      const dataSourceIndex = state.data.engineData.dataSources.findIndex(
        ds => ds.type === 'parsely'
      );
      if (dataSourceIndex !== -1) {
        state.data.engineData.dataSources[dataSourceIndex] = {
          ...state.data.engineData.dataSources[dataSourceIndex],
          ...action.payload,
        };
      }
    },
    setPianoExpanded: (state, action) => {
      state.etc.pianoExpanded = action.payload;
    },
    setCapsuleExpanded: (state, action) => {
      state.etc.capsuleExpanded = action.payload;
    },
    setQlikExpanded: (state, action) => {
      state.etc.qlikExpanded = action.payload;
    },
    setGa4Expanded: (state, action) => {
      state.etc.ga4Expanded = action.payload;
    },
    setMailchimpExpanded: (state, action) => {
      state.etc.mailchimpExpanded = action.payload;
    },
    setParselyExpanded: (state, action) => {
      state.etc.parselyExpanded = action.payload;
    },
    setDataSource: (state, action) => {
      state.data.engineData.dataSources = action.payload;
    },
  },
});

// Export the action creators
export const {
  setAILabsData,
  setAILabsEtc,
  setEngineCreationType,
  setEngineType,
  setEngineTitle,
  setEngineData,
  setPollingGuideline,
  setDEAGuideline,
  setKAIntentGuideline,
  setKAFallbackGuideline,
  setKAAnsweringGuideline,
  setKAFaqGuideline,
  setKASpamFilterGuideline,
  setKaPersonalizationToolChatGuideline,
  setKaPersonalizationToolGenerationGuideline,
  setKaDefaultGuidelines,
  setKaAnsweringExpanded,
  setKaIntentExpanded,
  setKaFallbackExpanded,
  setKaFaqExpanded,
  setKaSpamFilterExpanded,
  setKaPersonalizationToolChatExpanded,
  setKaPersonalizationToolGenerationExpanded,
  setIntents,
  setPianoDataSource,
  setCapsuleDataSource,
  setClickDataSource,
  setGa4DataSource,
  setMailchimpDataSource,
  setParselyDataSource,
  setPianoExpanded,
  setCapsuleExpanded,
  setQlikExpanded,
  setGa4Expanded,
  setMailchimpExpanded,
  setParselyExpanded,
  setDataSource,
} = aiLabsSlice.actions;

// Export the reducer
export default aiLabsSlice.reducer;
